// extracted by mini-css-extract-plugin
export default {"loadingContainer":"Checkout_loadingContainer__O3v7X"};